import React, { useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import { validateConcurrentSessionIfEnabled } from '../../utils/validateConcurrentSessionUtil';  
import { ReactComponent as SubscribeIcon } from '../../assets/icons/Rectangle.svg';
import HelpIcon from '@mui/icons-material/Help';
import { ReactComponent as AddHomeIcon } from '../../assets/icons/Home.svg';
//import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { ReactComponent as QueryBuilderIcon } from '../../assets/icons/Clip.svg';

const SubHeader = (props) =>{
  const { isAuthenticated, pageTitle, userType, tenants, selectedTenant, handleTenantChange, handleContentPackViewEvent, handleNavigateToTenantAdmin, showTenantAdminLink, showNotificationLink, showCustomQueryBuilderLink, onSubscriptionMgtClick, onCustomQueryBuilderClick,resetSessionTimer } = props;
  const [activeButton, setActiveButton] = useState('contentPack');

  return (
    <Box className="subHeaderContent" sx={{ width: '100%', height: 40, bgcolor: '#f5f5f5', px: 0, borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {isAuthenticated && (
        <Box sx={{ display: 'flex', alignItems: 'center',flex: 1,minWidth: 0}}>
          <Typography variant="subtitle1" sx={{ ml: 2, fontWeight: 'bold',overflowWrap: 'break-word',wordBreak: 'break-word',minWidth:200,maxWidth: 400, lineHeight: 1.2}}>
            {pageTitle ? pageTitle.split('-')[0].trim() : ''}
          </Typography>
          <Button
            data-content-pack-btn
            variant="contained"
            color="secondary"
            onClick={async () => {   
                if (await validateConcurrentSessionIfEnabled()) {  
                    setActiveButton('contentPack');   
                    handleContentPackViewEvent();   
                }  
            }} 
            sx={{
              ml: 5,
              backgroundColor: activeButton === 'contentPack' ? '#3d0808' : '#e0e0e0',
              color: activeButton === 'contentPack' ? '#fff' : '#333',
              textTransform: 'none',
              height: 28,
              minHeight: 28,
              padding: '2px 12px',
              fontSize: '0.95rem',
              flexShrink: 0,
              '&:hover': { backgroundColor: activeButton === 'contentPack' ? '#5a0b0b' : '#5a0b0b', color: '#fff' }
            }}
            startIcon={<InsertChartIcon />}
          >
            Content Packs
          </Button>
          {Array.isArray(tenants) && tenants.length > 0 && (
            <>
              <FormControl sx={{ ml:2, minWidth: 200, height: 28 }} size="small">
                <InputLabel id="tenant-select-label">Tenants</InputLabel>
                <Select
                  labelId="tenant-select-label"
                  id="tenant-select"
                  value={selectedTenant}
                  onChange={handleTenantChange}
                  label="Tenants"
                  sx={{ height: 28, backgroundColor: 'white' }}
                >
                  <MenuItem value="Select Tenant">Select Tenant</MenuItem>
                  {tenants.map((tenant, idx) => (
                    <MenuItem key={tenant.TenantId ? tenant.TenantId : idx} value={tenant.TenantId ? tenant.TenantId : idx}>
                      {tenant.DisplayName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
         <ButtonGroup variant="outlined" size="small" sx={{ mr: 2, height: 30, pt: 0.25, flexShrink: 0 }}>
  {showTenantAdminLink  && (
    <Button
      startIcon={<AddHomeIcon />}
      onClick={() => { setActiveButton('tenantAdmin'); handleNavigateToTenantAdmin(); }}
      color="inherit"
      sx={{
        backgroundColor: activeButton === 'tenantAdmin' ? '#3d0808' : '#e0e0e0',
        color: activeButton === 'tenantAdmin' ? '#fff' : '#333',
        borderColor: '#bdbdbd',
        textTransform: 'none',
        height: 24,
        minHeight: 24,
        py: 0,
        '&:hover': { backgroundColor: activeButton === 'tenantAdmin' ? '#5a0b0b' : '#5a0b0b', color: '#fff' }
      }}
    >
      Management Console
    </Button>
  )}
  {showNotificationLink && (
    <Button
      startIcon={<SubscribeIcon />}
      onClick={() => { setActiveButton('subscriptions'); onSubscriptionMgtClick(); }}
      color="inherit"
      sx={{
        backgroundColor: activeButton === 'subscriptions' ? '#3d0808' : '#e0e0e0',
        color: activeButton === 'subscriptions' ? '#fff' : '#333',
        borderColor: '#bdbdbd',
        textTransform: 'none',
        height: 24,
        minHeight: 24,
        py: 0,
        '&:hover': { backgroundColor: activeButton === 'subscriptions' ? '#5a0b0b' : '#5a0b0b', color: '#fff' }
      }}
    >
      Subscriptions Management
    </Button>
  )}
  {showCustomQueryBuilderLink && (
    <Button
      startIcon={<QueryBuilderIcon />}
      onClick={async () => {   
                if (await validateConcurrentSessionIfEnabled()) {  
                    setActiveButton('customQuery');   
                    onCustomQueryBuilderClick();   
                    resetSessionTimer?.();   
                }  
            }} 
      color="inherit"
      sx={{
        backgroundColor: activeButton === 'customQuery' ? '#3d0808' : '#e0e0e0',
        color: activeButton === 'customQuery' ? '#fff' : '#333',
        borderColor: '#bdbdbd',
        textTransform: 'none',
        height: 24,
        minHeight: 24,
        py: 0,
        '&:hover': { backgroundColor: activeButton === 'customQuery' ? '#5a0b0b' : '#5a0b0b', color: '#fff' }
      }}
    >
      Custom Query Builder
    </Button>
  )}
</ButtonGroup>
      </Box>
    </Box>
    
  );
}

export default SubHeader;